import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Card} from 'material-ui/Card';
import compose from 'recompose/compose';
import ViewTitle from 'admin-on-rest/lib/mui/layout/ViewTitle';
import Title from 'admin-on-rest/lib/mui/layout/Title';
import PageDescription from '../components/PageDescription';
import DefaultActions from 'admin-on-rest/lib/mui/detail/ShowActions';
import translate from 'admin-on-rest/lib/i18n/translate';
import withPermissionsFilteredChildren from 'admin-on-rest/lib/auth/withPermissionsFilteredChildren';

/**
 * A class for displaying Location Audit information from path and list of contents
 */
export class ShowLocationAudit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            record: {},
            auditId: null,
        };
    }

    getBasePathUpOne() {
        const {location} = this.props;
        return location.pathname
            .split('/')
            .slice(0, -3)
            .join('/');
    }

    render() {
        const {
            actions = <DefaultActions/>,
            title,
            children,
            data,
            desc,
            isLoading,
            resource,
            hasList,
            translate,
            version,
        } = this.props;

        if (!children) return null;
        const basePath = this.getBasePathUpOne();

        const auditId = this.state.auditId;
        if (auditId) {
            data.audit_uuid = auditId;
        }

        const titleElement = data ? (
            <Title title={title} record={data} defaultTitle="Location Audit"/>
        ) : (
            ''
        );
        const descriptionElement = data ? (
            <PageDescription record={data} desc={desc}/>
        ) : (
            ''
        );

        return (
            <div>
                <Card style={{opacity: isLoading ? 0.8 : 1}}>
                    {actions &&
                    React.cloneElement(actions, {
                        basePath,
                        data,
                        hasList,
                        resource,
                    })}
                    <ViewTitle title={titleElement}/>
                    {descriptionElement}
                    {data &&
                    React.cloneElement(children, {
                        resource,
                        basePath,
                        record: data,
                        translate,
                        version,
                    })}
                </Card>
            </div>
        );
    }
}

ShowLocationAudit.propTypes = {
    actions: PropTypes.element,
    children: PropTypes.element,
    data: PropTypes.object,
    desc: PropTypes.any,
    hasList: PropTypes.bool,
    id: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    resource: PropTypes.string.isRequired,
    title: PropTypes.any,
    translate: PropTypes.func,
    version: PropTypes.number.isRequired,
};

/**
 * Extract data for display from location path
 *
 * @param props
 * @return {*}
 */
function extractDataFromPath(props) {
    const {location} = props;
    if (location && location.pathname) {
        const pathArray = location.pathname.split('/');
        return {
            'resource': pathArray[1],
            'location_id': pathArray[2],
            'audit_uuid': pathArray[3],
        };
    }
    return null;
}

function mapStateToProps(state, props) {
    const path = extractDataFromPath(props);
    const pathProps = {
        'location_id': path.location_id,
        'audit_uuid': path.audit_uuid,
        data: {
            'location_id': path.location_id,
            'audit_uuid': path.audit_uuid,
        }
    };
    return {
        id: decodeURIComponent(props.match.params.id),
        data: pathProps ? pathProps : null,
        isLoading: state.admin.loading > 0,
        version: state.admin.ui.viewVersion,
    };
}

const enhance = compose(
    connect(mapStateToProps),
    translate,
    withPermissionsFilteredChildren
);

export default enhance(ShowLocationAudit);


// WEBPACK FOOTER //
// ./src/Fuse/admin/ShowLocationAudit.js